<template>
  <keep-alive :include="/list/">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: "index"
};
</script>

<style scoped>
</style>
